import { Button } from '@axo/ui-core/components/Button';
import { Modal } from '@axo/ui-core/components/Modal';
import { Text } from '@axo/ui-core/components/typography';
import {
  TermsAndConditions,
  TermsAndConditionsType,
} from '../@types/Terms.types';
import styles from '../Consent.module.scss';

interface ITermsAndConditions {
  term: TermsAndConditionsType;
  terms: TermsAndConditions[];
  onClick: () => void;
}

export const TermsModal = ({ term, terms, onClick }: ITermsAndConditions) => {
  const _term = terms.find((t) => t.tc_type === term);

  if (!_term) return null;

  return (
    <Modal
      open={true}
      hasClose={true}
      onClose={onClick}
      data-testid="terms-and-conditions-modal"
      className={styles.terms}
    >
      <Modal.Header>
        <Modal.Title size="l">{_term.modal_title}</Modal.Title>
        <Modal.Subtitle>
          <Text size={'m'}>{_term.version}</Text>
        </Modal.Subtitle>
      </Modal.Header>

      <Text size="s" dangerouslySetInnerHTML={{ __html: _term.body }} />

      <Modal.Actions>
        <Button
          onClick={onClick}
          data-testid="terms-and-conditions-action-button"
        >
          {_term.action_label}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
